import { resolvePageSeo } from "./resolvePageSeo";
import type { ISEOProps, IResolvedPageSEO, TPageSEOKey } from "./types/core";

export const generateSEO = (
  page: TPageSEOKey,
  seo?: Partial<ISEOProps>
): IResolvedPageSEO => {
  return resolvePageSeo(page, seo);
};
